export enum enumBacStatusToOpenAfterFicaApproval {
  Open=1,
  Limited
}


export namespace enumBacStatusToOpenAfterFicaApproval {
  export function values() {
    return Object.keys(enumBacStatusToOpenAfterFicaApproval).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
